<template>
  <!-- 智慧城管 -->
  <div class="scheme_container">
    <div class="scheme_wrap">
      <div class="title_wrap">{{pageData.title}}</div>

      <div class="content_wrap">
        <div class="article_box unify_article">{{pageData.text.text1}}</div>
        &nbsp;
        <div class="img_wrap" v-for="( item, index ) in pageData.imgArr" :key="`${index}-img`">
          <img :src="item.imgSrc" alt="" />
        </div>
         &nbsp;
        <div class="article_wrap" v-for="( item, index ) in pageData.text.textArr" :key="index">
          <div class="subtitle">{{item.textTitle}}</div>
          <div class="text unify_article" v-for="(itemText, indexText) in item.textContent" :key="`${index}-${indexText}`">
            {{itemText}}
          </div>
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageData: {
          title: "智慧城管",
          text: {
            text1: "瑞谦智慧城管解决方案本着创新、协调、开放、共享的思路，运用信息化、智慧化、大数据等技术手段，通过科技创新带动理念创新、机制创新、监管创新、服务创新，推动城市管理向城市服务转变，提升城市管理能力和服务水平的现代化。 建设“两个中心”和“一套机制”的管理模式。",
            textArr: [
              {
                textTitle: "城管监督中心",
                textContent: ["通过热线电话、现场到访、网络反馈、人员信息采集等途径进行民生诉求、设施、案件的收集，根据立案条件自动分配责任单位，并对案件处理情况进行监督。"]
              },
              {
                textTitle: "城管指挥中心",
                textContent: ["基于城市视频监控网络及智能检测设备的部署，提取海量城管大数据到智慧城市管理平台进行分析，出现违规行为时自动预警，指挥中心可以现场进行指挥调度或者派发给本辖区的城管人员进行确认和处理。"]
              },
              {
                textTitle: "监督考核评价机制",
                textContent: ["运用综合评价模型，从受理数量、结案数量、按期处置率等维度，按区域、按部门、按岗位对城市管理工作的各个方面进行考核评价，并以图表形式直观展示评价结果。建立科学完善的监督考核评价体系，能够落实城市管理责任、提高城市管理效能、改善城市管理形象。同时，通过案件发生趋势对城管工作进行前瞻性的研判指导。"]
              }
            ]
          },
          imgArr: [
            {
              imgSrc: require("@/assets/img/solution/pageImg/6.jpg"),
              text: "城市视频监控网络及智能检测设备"
            },
          ]
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import "@/views/solution/unifyStyle";
</style>
